export default "__VITE_ASSET__BAAoB821__"